import { memo } from "react";
import { Route as RouteTS } from "./types";
import { useRoutes } from "react-router-dom";

/** Custom Routes Component Props
 *
 * @author Dave Nivera
 */
type Props = {
  className?: string;
  routes: RouteTS[];
};

/** Custom Routes
 *
 * @author Dave Nivera
 */
function CustomRoutes(props: Props) {
  const { routes } = props;
  const element = useRoutes(routes);

  return element;
}

export default memo(CustomRoutes);
